import { render, staticRenderFns } from "./UserAd.vue?vue&type=template&id=08769186&scoped=true&"
import script from "./UserAd.vue?vue&type=script&lang=js&"
export * from "./UserAd.vue?vue&type=script&lang=js&"
import style0 from "./UserAd.vue?vue&type=style&index=0&id=08769186&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08769186",
  null
  
)

export default component.exports